import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b653dff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "footerWrapper",
  class: "footer-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", {
      class: "indicator-wrapper",
      onClick: $setup.toggleShowSeatsLayout
    }, [..._hoisted_3]),
    ($props.seatsSelectable)
      ? (_openBlock(), _createBlock($setup["SeatSelection"], {
          key: 0,
          ref: "seatSelection",
          turnId: $props.turnId,
          bookingDates: $props.bookingDates,
          selectedDateInfo: $props.selectedDateInfo,
          duplicateSeatNo: $props.duplicateSeatNo,
          autoSeatAssign: $setup.autoSeatAssign,
          currentBookInterval: $setup.BookIntervalCode.DAY,
          onOnClickSeat: $setup.emitOnClickSeat,
          onOnChangedAutoSeatAssign: $setup.toggleAutoSeatAssgin,
          onOnFetchedSeatLayout: $setup.emitOnFetchedSeatLayout
        }, null, 8 /* PROPS */, ["turnId", "bookingDates", "selectedDateInfo", "duplicateSeatNo", "autoSeatAssign", "currentBookInterval"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["PaymentFooterWithDuplicatedSeat"], {
      turnId: $props.turnId,
      getOnBusStopId: $props.getOnBusStopId,
      getOffBusStopId: $props.getOffBusStopId,
      bookingDates: $props.bookingDates,
      oneTimeFare: $props.oneTimeFare,
      totalAmount: $props.totalAmount,
      autoSeatAssign: $setup.autoSeatAssign,
      seatsSelectable: $props.seatsSelectable,
      currentBookInterval: $setup.BookIntervalCode.MONTH,
      realBookableDatesLength: $props.realBookableDatesLength
    }, null, 8 /* PROPS */, ["turnId", "getOnBusStopId", "getOffBusStopId", "bookingDates", "oneTimeFare", "totalAmount", "autoSeatAssign", "seatsSelectable", "currentBookInterval", "realBookableDatesLength"])
  ], 512 /* NEED_PATCH */))
}